import i18n from '@/i18n';

interface DefaultTranslationType {
	[key: string]: string | DefaultTranslationType | undefined;
}

const isMessageLeaf = (value: unknown): boolean => {
	if (typeof value === 'string') {
		return true;
	}
	if (!value || typeof value !== 'object') {
		return false;
	}
	// vue-i18n message AST nodes expose `loc.source`
	return 'loc' in value;
};

/**
 * Returns a flat map of immediate children for a locale key.
 * Leaf values are resolved with `t()` so linked messages (`@:...`) work.
 */
export const getTranslationObject = <T = DefaultTranslationType>(
	key: string
): T => {
	const translation = i18n.global.tm(key);
	return Object.entries(translation).reduce(
		// biome-ignore lint/suspicious/noExplicitAny: Init Biome
		(acc: any, [translationKey, value]: [string, any]) => {
			const leafKey = `${key}.${translationKey}`;
			if (isMessageLeaf(value) && i18n.global.te(leafKey)) {
				acc[translationKey] = i18n.global.t(leafKey);
			} else {
				acc[translationKey] = value?.loc?.source;
			}
			return acc;
		},
		{}
	);
};
